import React from 'react';
import type { SenderProfile } from '../../../lib/api';
import styles from './sender-profiles.module.css';

interface SenderProfileReadRowProps {
  profile: SenderProfile;
}

const FIELD_DEFINITIONS: ReadonlyArray<{
  term: string;
  key: 'label' | 'nameFieldPath' | 'emailFieldPath';
  mono: boolean;
}> = [
  { term: 'Label', key: 'label', mono: false },
  { term: 'Name field', key: 'nameFieldPath', mono: true },
  { term: 'Email field', key: 'emailFieldPath', mono: true },
];

export const SenderProfileReadRow: React.FC<SenderProfileReadRowProps> = ({ profile }) => {
  return (
    <li className={styles.profileSummary}>
      <dl>
        {FIELD_DEFINITIONS.map(({ term, key, mono }) => (
          <React.Fragment key={term}>
            <dt>{term}</dt>
            <dd data-mono={mono || undefined}>{profile[key] || '—'}</dd>
          </React.Fragment>
        ))}
      </dl>
    </li>
  );
};
